import styled from 'styled-components';
import { gap } from '../../../juristec-ui/styles/theme';

export const VideoDiv = styled.div`
 display: flex;
 flex-direction: column;
 align-items: center;
 justify-content: center;
 width: 90%;
 heigth: 90%;
 margin: auto;
 min-height: 350px;
 ${gap('5px', 'column')};
`;

export const VideoContainer = styled.div`
  box-sizing: border-box;
  width: 90%;
  heigth: 90%;
  margin: auto;
  aspect-ratio: 16 / 9;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  border-radius: 8px;

  background-color: ${({ theme }) => theme.containerHover};

  overflow: hidden;
`;

export const VideoIframe = styled.iframe`
  width: 100%;
  aspect-ratio: 16 / 9;

  border: 0;
  border-radius: 8px;
`;

export const VideoErrorMsg = styled.span`
  font-size: 10px;
  color: ${({ theme }) => theme.error};
`;

export const VideoDescription = styled.div`
  width: 90%;
  font-size: 12px;
  color: white;
`;
